// ====================
// components/ContactSection.js
// ====================

import React from 'react';
import { Mail, Linkedin, MapPin, Github } from 'lucide-react';

const ContactSection = () => {
  const contactMethods = [
    {
      icon: <Mail size={24} />,
      value: 'nicole.amaral@mymail.champlain.edu',
      href: 'mailto:nicole.amaral@mymail.champlain.edu'
    },
    {
      icon: <Linkedin size={24} />,
      value: 'nicole-c-amaral',
      href: 'https://www.linkedin.com/in/nicole-c-amaral'
    },
    {
      icon: <Github size={24} />,
      value: 'nicoleamaral',
      href: 'https://github.com/nicoleamaral'
    },
    {
      icon: <MapPin size={24} />,
      value: 'Burlington, VT',
      href: '#'
    }
  ];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Get In Touch</h2>
        
        <div className="contact-content"> 
            <div className="contact-methods">
              {contactMethods.map((method, index) => (
                <a key={index} href={method.href || '#'} className="contact-method">
                  {method.icon}

                    <span>{method.value}</span>
                </a>
              ))}
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default ContactSection;